import type { ReactNode } from "react";
import { ButtonGroup, Chip } from "@swot/base-components";
import type { CmtsPermissionSet } from "../types/pageConfig.types.js";

export function CmtsPermissionActionBar({ permission, effectivePermissions, children }: { readonly permission: CmtsPermissionSet; readonly effectivePermissions?: readonly string[] | undefined; readonly children?: ReactNode | undefined }) {
  const granted = new Set(effectivePermissions ?? []);
  const actions = Object.entries(permission).filter(([, value]) => typeof value === "string" && value.length > 0);
  return (
    <section className="cmts-page-action-bar" aria-label="Page actions and permissions">
      <div className="cmts-chip-row">
        {actions.map(([action, code]) => <Chip key={action} label={`${action}: ${granted.has(String(code)) ? "allowed" : "controlled"}`} tone={granted.has(String(code)) ? "success" : "neutral"} />)}
      </div>
      <ButtonGroup label="Configured page actions">{children}</ButtonGroup>
    </section>
  );
}
